<template>
  <div class="DaShu">
    <!--春季：3-5月-->
    <div class="spring" v-if="nowMoth >= 3 && nowMoth <= 5">
      <div class="banner">
        <img width="100%" src="../../../assets/img/DaShu/DaShu_Banner_spring.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/DaShu/spring_pipa.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/DaShu/spring_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              大五星号称枇杷之王，是我国目前最大果型的枇杷品种之一。曾获“99昆明世界园艺博览会’’银质奖。其主要特点是果实大，商品性好，果核小，果肉厚。平均单果重79克，最大果重194克。果实含可溶性固形物13.5%。果皮色泽金黄，外观诱人。丰产性好。大树镇2021年枇杷种植3000亩左右，产地主要位于新民村、料林村和山羊坪社区。
            </p>
            <p>
              大树镇2021年黄果柑种植约4000亩,主要种植于松林村、山羊坪社区。黄果柑是由橘和橙天然杂交而来的柑橘品种，果味酸甜适口，果粒饱满多汁，在汉源有300多年种植历史，当地人俗称青果、黄金果，素有“迎春第一果”之称。黄果柑属于无核品种，果粒饱满，带着柑橘的自然酸甜清香，一口咬下去，饱满柔嫩，润甜适口，含有丰富的维生素C、钙、B-胡萝卜素、柠檬酸、等营养物质，能够有效抗氧化、抗衰老、增强人体的免疫力。还含有膳食纤维和果胶，能够降低体内的胆固醇，对预防冠心病、动脉硬化等疾病有很好的作用。
            </p>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/DaShu/spring_square.png')"
        color="#DC6A06" borderBottomColor="#EBA970" boxBorderColor="#EBA970" btnBJcolor="rgb(234, 182, 134)"
        hoverBJcolor="#DB7312">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/DaShu/spring_square.png')"
        color="#DC6A06" borderBottomColor="#EBA970"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/DaShu/spring_square.png')" color="#DC7312"
        borderBottomColor="#EBA970" boxBorderColor="#EBA970"></ztxzList>
    </div>
    <!-- 夏季：6-8月 -->
    <div class="summer" v-else-if="nowMoth >= 6 && nowMoth <= 8">
      <div class="banner">
        <img width="100%" src="../../../assets/img/DaShu/Dashu_Banner_summer.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/DaShu/summer_putaoPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/DaShu/summer_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p style="line-height: 30px;">
              大树镇葡萄观光采摘园位于大树镇麦坪社区、新民村，占地1000余亩，前期主要葡萄品种：夏黑、户太八号、美人指、金手指、巨玫瑰、红乳、红提、红富士、阳光玫瑰、克伦森等优质葡萄品种10余种，是全县最大规模的集生产、观光、科教于一体的连片葡萄采摘观光园。汉源县大树镇的葡萄取名为“汉源阳光葡萄”，因为阳光代表的是健康、欣欣向荣，“汉源阳光葡萄”也是健康的、安全的、营养的。“汉源阳光葡萄”拥有葡萄种植得天独厚的自然条件，昼夜温差大，阳光充足，空气清新，水质优良，是夏黑、巨玫瑰、美人指、金手指等多种葡萄品种种植的最佳生态区域。规范化的建园、标准化的栽培管理更造就了“汉源阳光葡萄”的优秀品质，大树镇“月亮湾葡萄园”也成为“汉源阳光葡萄”品牌的基地。
            </p>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/DaShu/summer_square.png')"
        color="#4DB12E" borderBottomColor="#4DB12E" boxBorderColor="#9DCF8A" btnBJcolor="#A8D698" hoverBJcolor="#56B438">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/DaShu/summer_square.png')"
        color="#4DB12E" borderBottomColor="#4DB12E"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/DaShu/summer_square.png')" color="#4DB12E"
        borderBottomColor="#4DB12E" boxBorderColor="#9DCF8A"></ztxzList>
    </div>
    <!-- 秋季：9-11月 -->
    <div class="autumn" v-else>
      <div class="banner">
        <img width="100%" src="../../../assets/img/DaShu/Dashu_Banner_autumn.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/DaShu/autumn_yaocaiPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/DaShu/autumn_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              大树镇高山中药材种植地主要分布于大维村、白玉村与桂贤村，药材种类主要有当归、牛膝、党参、重楼，种植面积达2000亩，2022年预计总产值2500万元。海拔千米以上的高山地区与低山相比气温明显较低，尤其是夏季，高山气候凉爽宜人，日夜温差较大，降雨充沛，植被茂密，常年云雾缭绕，空气、土壤、环境湿度较高，紫外光强，但林缘、林下直射光较弱，土壤大部分为黄棕壤、白鳝土，有机质含量较高，这些条件恰是大多数中药材（尤其是根茎类药材）生长所必需的。很多药材（如党参）只有在高山生长才有较高的药用价值与经济价值。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/DaShu/autumn_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/DaShu/autumn_square.png')"
        color="#8D582A" borderBottomColor="#8D582A" boxBorderColor="#CEC3B8" btnBJcolor="#C1A78F" hoverBJcolor="#8C5725">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/DaShu/autumn_square.png')"
        color="#8D582A" borderBottomColor="#8D582A"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/DaShu/autumn_square.png')" color="#8D582A"
        borderBottomColor="#8D582A" boxBorderColor="#CEC3B8"></ztxzList>
    </div>
  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
import { getServerDate, matterQuery } from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  name: 'DaShu',
  components: { ztxzList, ConvenientService ,GovernmentServices},
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: this.$route.params.mapId || null,  //点位ID
      matterList: [],  //事项列表
      villages: [],  //乡镇列表
      name:'大树镇'
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);

  },
  // mounted() {
  //   // if (this.$route.params.mapId) {
  //   //   sessionStorage.setItem('mapId', this.mapId)
  //   // }
  //   // if (sessionStorage.getItem('mapId')) {
  //   //   this.mapId = sessionStorage.getItem('mapId');
  //   // }
  //   this.getData()
  //   this.getMatterList()
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 获取便民办事
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res,'事项列表')
  //       if (res.data.code == 200) {
  //         if (res.data.rows && res.data.rows.length > 0) {
  //           this.matterList = res.data.rows.slice(0, 5);
  //         } else {
  //           // this.$message.error('暂无事项！')
  //           console.log('暂无事项')
  //         }
  //       } else {
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n, '时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  // },
};
</script>
<style scoped>
.DaShu {
  background: url('../../../../src/assets/img/DaShu/DaShu_Bj.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  text-indent: 2em;
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 23px;
}

.spring .top_title {
  color: #DC7312;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #DC7312;
  height: 12%;
}

.summer .top_title {
  color: #4DB12E;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #4DB12E;
  height: 12%;
}

.autumn .top_title {
  color: #8D582A;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #8D582A;
  height: 12%;
}



.con2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.list_item {
  background-color: #F9F9F9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  padding: 0 10px;
  border: 1px solid #EBA970;
  margin-bottom: 20px;
}

.list_item_left {
  font-size: 18px;
  font-weight: bold;
}

.banshi_btn {
  background-color: rgb(234, 182, 134);
  color: rgb(255, 255, 255);
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 7px;
}

.banshi_btn:hover {
  background-color: #DB7312;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}</style>